<template lang="pug">
b-modal#editMissionGlobalModal(
  ref="editMissionGlobal"
  :title="modalTitle"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  @ok="done"
  @show="reset"
  @shown="shown"
  @hidden="onModalHidden"
)
  b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
    b-form-group(:label="$t('ui.en_title')").mb-2
      DebounceInput(
        ref="en_title"
        size="sm"
        type="text"
        :dirty="$v.en_title.$dirty"
        :error="$v.en_title.$error"
        v-model.trim.lazy="$v.en_title.$model"
        :disabled="loading"
      )
      ValidateResult(:value="$v.en_title" :name="$t('ui.en_title')")
    b-form-group(:label="$t('ui.cn_title')").mb-2
      DebounceInput(
        ref="cn_title"
        size="sm"
        type="text"
        :dirty="$v.cn_title.$dirty"
        :error="$v.cn_title.$error"
        v-model.trim.lazy="$v.cn_title.$model"
        :disabled="loading"
      )
      ValidateResult(:value="$v.cn_title" :name="$t('ui.cn_title')")
    b-form-group(:label="$t('ui.local_title')").mb-2
      DebounceInput(
        ref="local_title"
        size="sm"
        type="text"
        :dirty="$v.local_title.$dirty"
        :error="$v.local_title.$error"
        v-model.trim.lazy="$v.local_title.$model"
        :disabled="loading"
      )
      ValidateResult(:value="$v.local_title" :name="$t('ui.local_title')")
    b-form-group(:label="$t('ui.point')").mb-2
      DebounceInput(
        ref="badgeInput"
        size="sm"
        type="text"
        :dirty="$v.badge.$dirty"
        :error="$v.badge.$error"
        v-model.trim.lazy="$v.badge.$model"
        :disabled="loading"
      )
      ValidateResult(:value="$v.badge" :name="$t('ui.point')")
    div.row
      div.col
        b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
  div(slot="modal-cancel")
    SubmitButton(:loading="loading" icon="fa fa-ban" :text="$t('ui.cancel')" isModal=true)
  div(slot="modal-ok")
    SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import DebounceInput from "@/library/DebounceInput";
import CampaignLookup from "@/library/CampaignLookup";
import { integer, required, minValue, minLength } from "vuelidate/lib/validators";
import ValidateResult from "@/library/ValidateResult";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    CampaignLookup,
    ValidateResult
  },
  props: {
    item: {
      type: Object,
      default: null
    },
    submitAsStatusEnable: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      mission_id: null,
      en_title: "",
      cn_title: "",
      local_title: "",
      badge: "",
      credit: "",
      inbox: "",
      campaign: "",
      didSubmitSuccess: false,
      loading: false,
      feedback: {
        success: true,
        status: ""
      }
    };
  },
  computed: {
    inboxHasValue() {
      return String(this.inbox || "").trim() !== "";
    },
    modalTitle() {
      return this.submitAsStatusEnable
        ? this.$t("ui.combine.enable_mission_reward")
        : this.$t("ui.combine.edit_mission_reward");
    },
  },
  validations: {
    en_title: {
      required,
      minLength: minLength(3)
    },
    cn_title: {
      required,
      minLength: minLength(3)
    },
    local_title: {
      required,
      minLength: minLength(3)
    },
    badge: {
      required,
      integer,
      minValue: minValue(1)
    }
  },
  watch: {
    inbox() {
      if (!this.inboxHasValue) {
        this.campaign = "";
      }
    }
  },
  methods: {
    done(evt) {
      evt.preventDefault();
      if (this.$v.$invalid) return;

      this.submit();
    },
    parseRewardPayload() {
      const raw = this.item && this.item.reward_payload;
      if (raw == null || raw === "") {
        return {};
      }
      if (typeof raw === "object" && !Array.isArray(raw)) {
        return raw;
      }
      if (typeof raw === "string") {
        try {
          return JSON.parse(raw);
        } catch (e) {
          return {};
        }
      }
      return {};
    },
    optionalInt(str) {
      if (str === "" || str == null || String(str).trim() === "") {
        return null;
      }
      const n = parseInt(String(str).trim(), 10);
      return Number.isFinite(n) ? n : NaN;
    },
    optionalDecimal(str) {
      if (str === "" || str == null || String(str).trim() === "") {
        return null;
      }
      const n = Number(String(str).trim());
      return Number.isFinite(n) ? n : NaN;
    },
    rewardProvided(badgeVal, creditVal, inboxVal, campaignStr) {
      const camp = campaignStr != null && String(campaignStr).trim() !== "";
      return (
        badgeVal != null ||
        creditVal != null ||
        inboxVal != null ||
        camp
      );
    },
    submit() {
      const badgeVal = this.optionalInt(this.badge);
      const creditVal = this.optionalDecimal(this.credit);
      const inboxVal = this.optionalInt(this.inbox);
      const campaignTrim =
        this.campaign != null ? String(this.campaign).trim() : "";

      // if (
      //   Number.isNaN(badgeVal) ||
      //   Number.isNaN(creditVal) ||
      //   Number.isNaN(inboxVal)
      // ) {
      //   this.$helpers.showDialog(
      //     this.$t("ui.alert"),
      //     this.$t("message.mission_invalid_reward_numbers"),
      //     "error"
      //   );
      //   return;
      // }

      // if (!this.rewardProvided(badgeVal, creditVal, inboxVal, campaignTrim)) {
      //   this.$helpers.showDialog(
      //     this.$t("ui.alert"),
      //     this.$t("message.mission_reward_at_least_one"),
      //     "error"
      //   );
      //   return;
      // }

      // if (inboxVal != null && campaignTrim === "") {
      //   this.$helpers.showDialog(
      //     this.$t("ui.alert"),
      //     this.$t("message.mission_campaign_required_when_inbox"),
      //     "error"
      //   );
      //   return;
      // }

      let url = this.submitAsStatusEnable
        ? config.globalMissionStatusUpdateUrl()
        : config.globalMissionUpdateUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        audit_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        mission_id: this.mission_id,
        badge: badgeVal,
        credit: creditVal,
        inbox: inboxVal,
        campaign: campaignTrim === "" ? null : campaignTrim,
        title_en: this.en_title,
        title_cn: this.cn_title,
        title_local: this.local_title
      };
      if (this.submitAsStatusEnable) {
        json.new_status = true;
      }

      this.feedback.success = true;
      this.loading = true;

      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.didSubmitSuccess = true;
                this.$emit("clicked");
                this.$refs.editMissionGlobal.hide();
              } else {
                this.$helpers.handleFeedback(this.feedback.status);
                this.$emit("failed", "edit_mission_reward", this.feedback.status);
                this.$refs.editMissionGlobal.hide();
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        }.bind(this),
        function() {
          this.loading = false;
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
        }.bind(this)
      );
    },
    reset() {
      this.feedback.success = true;
      this.feedback.status = "";
      this.didSubmitSuccess = false;
    },
    onModalHidden() {
      if (this.submitAsStatusEnable && !this.didSubmitSuccess && this.item) {
        this.$emit("status-enable-cancelled", this.item);
      }
      this.didSubmitSuccess = false;
    },
    shown() {
      const obj = this.parseRewardPayload();
      this.mission_id = this.item && this.item.mission_id;
      this.en_title = this.item.title_en;
      this.cn_title = this.item.title_cn;
      this.local_title = this.item.title_local;
      this.badge = obj.badge != null ? String(obj.badge) : "";
      this.credit = obj.credit != null ? String(obj.credit) : "";
      this.inbox = obj.inbox != null ? String(obj.inbox) : "";
      if (!String(this.inbox || "").trim()) {
        this.campaign = "";
      } else {
        this.campaign =
          obj.campaign != null ? String(obj.campaign) : "";
      }
      this.$nextTick(() => {
        if (this.$refs.en_title && this.$refs.en_title.$el) {
          this.$refs.en_title.$el.focus();
        }
      });
    }
  }
};
</script>

<style scoped>
.mission-edit-chip {
  display: flex;
  align-items: center;
  max-width: 100%;
  padding: 0.25rem 0.55rem 0.28rem;
  background: #f8f9fc;
  border: 1px solid #e6e9ef;
  border-radius: 6px;
  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.04);
}

.mission-edit-chip-input:disabled,
.mission-edit-chip-input[disabled] {
  flex: 1;
  min-width: 0;
  margin: 0;
  padding: 0;
  border: none;
  background: transparent !important;
  box-shadow: none !important;
  font-size: 13px;
  font-weight: 700;
  color: #2c3e50;
  opacity: 1;
  cursor: default;
  height: auto;
}

.mission-edit-chip-input:disabled::-webkit-input-placeholder {
  color: transparent;
}
</style>
